import { AnimatePresence, motion } from "framer-motion";
import { PropsWithChildren } from "react";

import { slideDown } from "@/theme/transitions";

interface ISlideDown extends PropsWithChildren {
  show: boolean;
}

export const SlideDown: React.FC<ISlideDown> = ({ show, children }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial="initial" animate="animate" exit="exit" variants={slideDown}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
